<template>
  <v-dialog v-model="config.status.active" max-width="600px">
    <v-btn flat slot="activator" color="blue darken-2" @click="init"><font-awesome-icon :icon="['fal', 'plus']"></font-awesome-icon>&nbsp;新規登録</v-btn>
    <v-card>
      <v-card-title class="grey lighten-3 blue-grey--text text--darken-4"><span class="headline">保護者の新規登録</span></v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-form ref="form" v-model="form.valid" lazy-validation>
            <v-layout wrap>
              <v-flex xs12 md6>
                <v-text-field label="姓" required counter
                  v-model="form.name[0]"
                  maxlength="10"
                  :rules="rules.name"></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field label="名" required counter
                  v-model="form.name[1]"
                  maxlength="10"
                  :rules="rules.name"></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field label="せい" required counter
                  v-model="form.kana[0]"
                  maxlength="10"
                  :rules="rules.kana"></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field label="めい" required counter
                  v-model="form.kana[1]"
                  maxlength="10"
                  :rules="rules.kana"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-combobox required
                  v-model="form.relation"
                  :items="meta.relations"
                  :rules="rules.relation"
                  label="続柄"></v-combobox>
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions class="grey lighten-3">
        <v-btn flat @click="close" color="blue darken-2">閉じる</v-btn>
        <v-spacer></v-spacer>
        <v-btn depressed color="blue darken-2 white--text" :disabled="!isValid" :loading="isLoading" @click="submit">登録する</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'clientAboutGuardiansModalInsert',
  components: {
  },
  data () {
    return {
      config: {
        status: {
          active: false,
          loading: false,
          initializing: false
        }
      },
      meta: {
        relations: [
          '父',
          '母',
          '祖父',
          '祖母',
          '夫',
          '妻',
          'おじ',
          'おば',
          '息子',
          '娘',
          '孫',
          '兄',
          '姉',
          '弟',
          '妹'
        ]
      },
      form: {
        valid: true,
        name: ['', ''],
        kana: ['', ''],
        relation: ''
      },
      rules: {
        name: [
          v => !!v || '必須項目です'
        ],
        kana: [
          v => !!v || '必須項目です',
          v => !/[^ぁ-ん]/.test(v) || '平仮名のみ入力有効です'
        ],
        relation: [
          v => !!v || '必須項目です'
        ]
      }
    }
  },
  created: function () {
  },
  mounted: function () {
  },
  methods: {
    init: function () {
      this.prepare()
    },
    prepare: function () {
      this.$set(this, 'form', {
        valid: true,
        name: ['', ''],
        kana: ['', ''],
        relation: ''
      })
    },
    update: function (values) {
      console.log(values)
    },
    submit: function () {
      if (this.$refs.form.validate()) {
        let fd = {
          name: [
            this.form.name.length > 0 ? this.form.name[0] : '',
            this.form.name.length > 1 ? this.form.name[1] : ''
          ],
          kana: [
            this.form.kana.length > 0 ? this.form.kana[0] : '',
            this.form.kana.length > 1 ? this.form.kana[1] : ''
          ],
          relation: this.form.relation ? this.form.relation : ''
        }
        this.$set(this.config.status, 'loading', true)
        this.axios.post(this.$url.api + 'user/about/insert/guardian', fd, {
          headers: {
            'user-token': this.$localStorage.get('jwt')
          }
        }).then(res => {
          console.log(res)
          this.$set(this.config.status, 'loading', false)
          if (res.data && res.data.success) {
            this.$set(this.config.status, 'loading', false)
            if (res.data && res.data.success) {
              this.$emit('emit', {
                action: 'insert',
                data: res.data.data
              })
            }
            this.close()
          }
        })
      }
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    }
  },
  computed: {
    isValid () {
      return this.form.valid
    },
    isLoading () {
      return this.config.status.loading
    },
    isSubmittable () {
      return Object.keys(this.form).filter(key => {
        return (this.form[key].required && this.form[key].value === '')
      }).length === 0
    },
    getItems () {
      return this.meta.relations
    }
  }
}
</script>
